import { render } from "./invoices_detail.vue?vue&type=template&id=5c9a7258&scoped=true"
import script from "./invoices_detail.vue?vue&type=script&lang=js"
export * from "./invoices_detail.vue?vue&type=script&lang=js"

import "./invoices_detail.vue?vue&type=style&index=0&id=5c9a7258&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c9a7258"]])

export default __exports__